/**
 * Defines the style family for basemap sessions.
 */
export type StyleFamily = "open" | "arcgis";
